import React, { FunctionComponent } from "react";

interface Props {
  taken: number;
  total: number;
}

/** Auslastungsbalken: leer, teilweise belegt oder ausgebucht. */
export const Meter: FunctionComponent<Props> = ({ taken, total }) => {
  const percentage = total > 0 ? Math.min(100, Math.round((taken / total) * 100)) : 0;
  const modifier = percentage >= 100 ? "" : percentage > 0 ? " meter__fill--partial" : " meter__fill--empty";

  return (
    <div className="meter">
      <div className="meter__track">
        <div className={`meter__fill${modifier}`} style={{ width: `${percentage}%` }} />
      </div>
      <span className="meter__value">{total > 0 ? `${taken}/${total}` : "–"}</span>
    </div>
  );
};
